export const DEFAULT_GAME_DURATION_MINUTES = 20;
export const MIN_GAME_DURATION_MINUTES = 15;
export const MAX_GAME_DURATION_MINUTES = 300;
export const START_TIME_ROUNDING_MINUTES = 15;

export const TOAST_DURATION_SHORT = 3000;
export const TOAST_DURATION_MEDIUM = 5000;
export const TOAST_DURATION_LONG = 7000;
